import eventMap from "./event-map";

const exceptions = {
  NO_WINDOW_SEND_EVENT: "NO_WINDOW_SEND_EVENT",
  FAILED_SEND_EVENT: "FAILED_SEND_EVENT",
  ILLEGAL_EVENT_TYPE: "ILLEGAL_EVENT_TYPE",
};

const data = {
  disabled: false,
};

export const disable = () => {
  data.disabled = true;
};

export const setProperty = (property, value) => {
  if (data[property]) {
    data[property] = value;
  }
};

const sendGaEvent = (event) => {
  if (!window.sendEvent) {
    reportAnalyticsError(exceptions.NO_WINDOW_SEND_EVENT)(event);
    return false;
  }

  try {
    window.sendEvent(event);
    return true;
  } catch (err) {
    reportAnalyticsError(exceptions.FAILED_SEND_EVENT)(err);
    return false;
  }
};

const reportAnalyticsError =
  (type) =>
  (...args) => {
    // TODO report to Sentry
    console.log(
      "Analytics error of type:",
      type,
      "payload:",
      JSON.stringify(args)
    );
  };

export const sendEvent = (type, payload) => {
  if (!eventMap[type]) {
    reportAnalyticsError(exceptions.ILLEGAL_EVENT_TYPE)(type);
    return false;
  }

  const eventCreator = eventMap[type] || (() => {});
  const event = eventCreator(payload);
  if (data.disabled) {
    console.log("Event skipped:", event);
    return false;
  }
  return sendGaEvent(event);
};
